import React from "react";
import cx from "classnames";
import useSheet from "react-jss";
import PropTypes from "prop-types";

import Portal from "../internal/Portal";

export const CENTER = "center";
export const TOP_LEFT = "top-left";
export const TOP_RIGHT = "top-right";
export const TOP_CENTER = "top-center";
export const BOTTOM_LEFT = "bottom-left";
export const CENTER_LEFT = "center-left";
export const BOTTOM_RIGHT = "bottom-right";
export const CENTER_RIGHT = "center-right";
export const BOTTOM_CENTER = "bottom-center";

const PositionTypes = [
  CENTER,
  TOP_LEFT,
  TOP_RIGHT,
  TOP_CENTER,
  BOTTOM_LEFT,
  CENTER_LEFT,
  BOTTOM_RIGHT,
  CENTER_RIGHT,
  BOTTOM_CENTER
];

const enhancer = useSheet({
  "@keyframes fadeIn": {
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    }
  },
  backdrop: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    overflowY: "auto",
    position: "fixed",
    boxSizing: "border-box",
    backgroundColor: "rgba(0,0,0,.5)"
  },
  dialog: {
    padding: 0,
    width: "auto",
    flex: "1 1 0%",
    display: "flex",
    height: "500px",
    minHeight: "500px",
    minWidth: "1000px",
    maxWidth: "1000px",
    "-ms-flex": "1 1 0%",
    flexDirection: "column",
    backgroundColor: "white",
    "-ms-flex-direction": "column",
    "@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)": {
      marginLeft: 0
    },
    animation: "fadeIn .5s"
  },
  msDisplayFlex: {
    display: "-ms-flexbox"
  },
  [`${CENTER}-position`]: {
    alignItems: "center",
    justifyContent: "center",
    "-ms-flex-pack": "center",
    "-ms-flex-align": "center"
  },
  [`${TOP_LEFT}-position`]: {
    alignItems: "flex-start",
    justifyContent: "flex-start"
  },
  [`${TOP_RIGHT}-position`]: {
    alignItems: "flex-start",
    justifyContent: "flex-end"
  },
  [`${TOP_CENTER}-position`]: {
    alignItems: "flex-start",
    justifyContent: "center"
  },
  [`${BOTTOM_LEFT}-position`]: {
    alignItems: "flex-end",
    justifyContent: "flex-start"
  },
  [`${CENTER_LEFT}-position`]: {
    alignItems: "center",
    justifyContent: "flex-start"
  },
  [`${BOTTOM_RIGHT}-position`]: {
    alignItems: "flex-end",
    justifyContent: "flex-end"
  },
  [`${CENTER_RIGHT}-position`]: {
    alignItems: "center",
    justifyContent: "flex-end"
  },
  [`${BOTTOM_CENTER}-position`]: {
    alignItems: "flex-end",
    justifyContent: "center"
  }
});

Dialog.propTypes = {
  classes: PropTypes.object,

  open: PropTypes.bool,
  children: PropTypes.node,
  position: PropTypes.oneOf(PositionTypes),

  className: PropTypes.string,
  backdropClassName: PropTypes.string
};

Dialog.defaultProps = {
  open: false,
  position: CENTER
};

function Dialog(props) {
  const { classes } = props;

  return (
    <Portal open={props.open}>
      <div
        className={cx(
          classes.backdrop,
          classes.msDisplayFlex,
          classes[`${props.position}-position`],
          props.backdropClassName
        )}
      >
        <div
          className={cx(classes.dialog, classes.msDisplayFlex, props.className)}
        >
          {props.children}
        </div>
      </div>
    </Portal>
  );
}

export default enhancer(Dialog);



// WEBPACK FOOTER //
// ./src/module/components/Dialog.js